import React, { lazy } from 'react'
import { Route, Switch } from 'react-router'
import Welcome from '../components/welcome'
import { GIF_MAKER } from './index'

const CutOut = lazy(() => import(/* webpackChunkName: "creationCutOut" */ '../components/cut-out'))
const Animate = lazy(() => import(/* webpackChunkName: "creationAnimate" */ '../components/animate'))
const Upload = lazy(() => import(/* webpackChunkName: "creationUpload" */ '../components/upload'))

const LegacyGifMaker = lazy(() =>
    import(/* webpackChunkName: "gifMakerLegacy" */ '../../gif-maker/components/gif-maker')
)

export const VIDEO_TRIM = `/video-trim`
export const CUT_OUT = `/cut-out`
export const ANIMATE = `/animate`
export const DECORATE = `/decorate/caption`
export const UPLOAD = `/upload`

const GifMakerRoute = props => {
    return (
        <Switch>
            <Route exact path={`${GIF_MAKER}${UPLOAD}`} render={() => <Upload submitUrl={props.submitUrl} />} />
            <Route exact path={`${GIF_MAKER}${ANIMATE}`} render={() => <Animate />} />
            <Route exact path={`${GIF_MAKER}${CUT_OUT}`} render={() => <CutOut />} />
            <Route exact path={GIF_MAKER} render={() => <Welcome />} />
            <Route render={() => <LegacyGifMaker {...props} />} />
        </Switch>
    )
}

export default GifMakerRoute
